export const MealPackagingPivot = (json: IMealPackagingPivot): IMealPackagingPivotModel => {
	const fromJSON = (itemJson: IMealPackagingPivot) => {
		const {
			description_compartment_1,
			description_compartment_2,
			description_compartment_3,
			packaging_type_id,
			...rest
		} = itemJson
		return {
			descriptionCompartment1: description_compartment_1,
			descriptionCompartment2: description_compartment_2,
			descriptionCompartment3: description_compartment_3,
			id: packaging_type_id,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const MealPackagingType = (json: IMealPackagingType): IMealPackagingTypeModel => {
	const fromJSON = (itemJson: IMealPackagingType) => {
		const { meal_kind, compartments_qty, name, is_active, created_at, updated_at, pivot, ...rest } = itemJson
		return {
			isActive: is_active,
			name: LangContentToModel(name),
			mealKind: meal_kind,
			compartmentsQty: compartments_qty,
			createdAt: created_at ? new Date(created_at) : null,
			updatedAt: updated_at ? new Date(updated_at) : null,
			pivot: pivot ? MealPackagingPivot(pivot) : null,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const mealPackagingTypeToJSON = (obj: Partial<IMealPackagingTypeModel>): Partial<IMealPackagingType> => {
	const { isActive, ...rest } = obj
	return {
		is_active: isActive,
		...rest,
	}
}

export const mealPackagingPivotToJSON = (payload: Partial<IMealPackagingPivotModel>): Partial<IMealPackagingPivot> => {
	const { id, pivot } = payload

	return {
		description: pivot.description,
		packaging_type_id: id,
		description_compartment_1: pivot.descriptionCompartment1,
		description_compartment_2: pivot.descriptionCompartment2,
		description_compartment_3: pivot.descriptionCompartment3,
	}
}
